import type { BuddyUserContext } from './use-buddy-chat'

/**
 * The flow's Start node reads `conversation_custom_data` by these exact key names,
 * and the aiassist actions behind it validate the same shape with `extra="ignore"`
 * — so a renamed or re-cased key is dropped in silence rather than erroring. The
 * mixed snake/camel casing below is the spec's, not an oversight.
 */
export interface BuddyFlowCustomData {
  aom_uuid: string
  auth_id: string
  email?: string
  name?: string
  plan?: string
  balance?: number
  currency?: string
  conversionRate?: number
  roles?: string[]
  region?: string
  countryId?: string
  registeredIp?: string
  signupDate?: string
  page_url: string
}

export interface BuddyFlowIdentity {
  aomUuid: string
  /** Plivo auth id of the org, carried for log correlation on every flow action. */
  authId: string
}

export const buildBuddyFlowCustomData = (
  userContext: BuddyUserContext,
  pageUrl: string,
  identity: BuddyFlowIdentity,
): BuddyFlowCustomData => ({
  aom_uuid: identity.aomUuid,
  auth_id: identity.authId,
  email: userContext.email,
  name: userContext.name,
  plan: userContext.plan,
  balance: userContext.balance,
  currency: userContext.currency,
  conversionRate: userContext.conversionRate,
  roles: userContext.roles,
  region: userContext.region,
  countryId: userContext.countryId,
  registeredIp: userContext.registeredIp,
  signupDate: userContext.signupDate,
  page_url: pageUrl,
})
